/**
 * QueueElementCapChips — the "CAP used/limit" chips for a Queue-tab row
 * (MD-1147). A path row resolves its capped offers through GET /offer-caps'
 * path map: by tracker path id once live, by bank path id while waiting or
 * queued. An offer row is its own offer. "—" when nothing on the row has a cap.
 * For Media Devoted | Created By James Alexandrov
 */

import { FC } from 'react';
import type { QueueElement } from '@trafficpulse/shared';

import type { FlowOptimizerProvider } from '@/features/flow-optimizer/services/flow-optimizer-api';

import { PathOfferCapChips } from '@/features/offer-caps';

export interface QueueElementCapChipsProps {
  element: QueueElement;
  provider: FlowOptimizerProvider;
}

export const QueueElementCapChips: FC<QueueElementCapChipsProps> = ({ element, provider }) => (
  <PathOfferCapChips
    platform={provider}
    offerIds={element.layer === 'offers' ? [element.itemId] : []}
    pathIds={element.layer === 'paths' ? [element.itemId, element.bankId] : []}
    empty={<span className="text-muted-foreground">—</span>}
  />
);

export default QueueElementCapChips;
